module.exports = __webpack_public_path__ + "img/073426.a9c6ca5b.png";